var playerType = Object.freeze({
   HTML5_VIDEO: 'html5',
   YOUTUBE: 'youtube',
   IMAGE: 'image',
   NOT_SUPPORTED: 'not_supported'
});

export default playerType;
